import { getDecodedToken } from './auths';

export const hasPermission = (permission: string): boolean => {
  const decoded = getDecodedToken();
  if (!decoded?.authorities?.length) return false;

  return decoded.authorities.includes(permission);
};

export const hasAnyPermission = (permissions: string[]): boolean => {
  const decoded = getDecodedToken();
  if (!decoded?.authorities?.length) return false;

  return permissions.some(p => decoded.authorities.includes(p));
};
